import React from "react"
import { useIntl, FormattedMessage } from "react-intl"
import { useCurrentUser } from "#/components/context/user/UserContext"
import { FormRadioGroup, useFormContext } from "@carrotfertility/carotene-core-x"
import { useTheme, Stack, Alert } from "@carrotfertility/carotene-core"

export function PartnerRadioOptions(): JSX.Element {
  const theme = useTheme()
  const intl = useIntl()
  const { watch } = useFormContext()

  const { legallyMarried } = useCurrentUser()

  const formLegallyMarried = watch("legallyMarried")

  const showLegallyMarriedQuestion = legallyMarried === null

  const showPartnerAsDependentQuestion = formLegallyMarried === "No"

  const showAlert = showLegallyMarriedQuestion || showPartnerAsDependentQuestion

  return (
    <Stack spacing={theme.spacing(theme.tokens.spacing.md)}>
      {showAlert && (
        <Alert severity="info">
          <FormattedMessage defaultMessage="Provide the information below to see if your partner is eligible for coverage and savings at partner providers." />
        </Alert>
      )}
      {showLegallyMarriedQuestion && (
        <FormRadioGroup
          label={intl.formatMessage({ defaultMessage: "Are you legally married to your partner?" })}
          options={[
            { label: intl.formatMessage({ defaultMessage: "Yes" }), value: "Yes" },
            { label: intl.formatMessage({ defaultMessage: "No" }), value: "No" }
          ]}
          controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
          name="legallyMarried"
        />
      )}
      {showPartnerAsDependentQuestion && (
        <FormRadioGroup
          label={intl.formatMessage({ defaultMessage: "Do you claim your partner as a dependent on your taxes?" })}
          options={[
            { label: intl.formatMessage({ defaultMessage: "Yes" }), value: "Yes" },
            { label: intl.formatMessage({ defaultMessage: "No" }), value: "No" }
          ]}
          controllerProps={{ rules: { required: intl.formatMessage({ defaultMessage: "Required" }) } }}
          name="partnerAsDependent"
        />
      )}
    </Stack>
  )
}
